(function(){
  if (window.__mpnInf) return; window.__mpnInf = true;
  (function(){ var l = document.querySelector('#ProductGridContainer link[href*="/mpn-infinite-scroll.css"]'), c = l && l.closest('#ProductGridContainer');
    if (c && !document.querySelector('link[data-mpn-keep="mpn-infinite-scroll"]')) { var k = l.cloneNode(); k.setAttribute('data-mpn-keep', 'mpn-infinite-scroll'); c.parentNode.insertBefore(k, c); } })();
  if (!('IntersectionObserver' in window) || !window.fetch || !window.DOMParser) return;
  document.documentElement.classList.add('mpn-inf-on');
  var io = null, busy = false, current = null;

  function grid(){ return document.getElementById('product-grid'); }
  function box(){ return document.querySelector('[data-mpn-inf]'); }

  function fixWide(g){
    if (typeof window.mpnGridLayout === 'function') { window.mpnGridLayout(g); return; }
    var items = [].slice.call(g.querySelectorAll(':scope > .grid__item:not(.item__push)'));
    items.forEach(function(li){ li.classList.remove('mpn-last-wide'); });
    if (!g.getAttribute('data-mpn-next') && items.length % 2 === 1) items[items.length - 1].classList.add('mpn-last-wide');
  }

  function fail(b){
    b.classList.remove('is-loading');
    b.querySelector('.mpn-inf__btn').hidden = false;
  }

  function load(){
    var g = grid(), b = box();
    if (busy || !g || !b) return;
    var next = g.getAttribute('data-mpn-next');
    if (!next) { b.hidden = true; return; }
    busy = true;
    b.classList.add('is-loading');
    b.querySelector('.mpn-inf__btn').hidden = true;
    var u = new URL(next, location.href);
    u.searchParams.set('section_id', b.getAttribute('data-section-id'));
    fetch(u.toString(), { credentials: 'same-origin' })
      .then(function(r){ if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function(html){
        if (grid() !== g) return; // la grille a ete remplacee (filtre / tri) entre-temps
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ng = doc.getElementById('product-grid');
        if (!ng) throw new Error('grid');
        var frag = document.createDocumentFragment();
        [].slice.call(ng.children).forEach(function(li){
          if (li.classList.contains('item__push')) return;
          frag.appendChild(document.importNode(li, true));
        });
        g.appendChild(frag);
        var nn = ng.getAttribute('data-mpn-next');
        if (nn) g.setAttribute('data-mpn-next', nn); else g.removeAttribute('data-mpn-next');
        fixWide(g);
        if (typeof window.initializeScrollAnimationTrigger === 'function') {
          try { window.initializeScrollAnimationTrigger(g); } catch (e) {}
        } else {
          g.querySelectorAll('.scroll-trigger').forEach(function(el){ el.classList.remove('scroll-trigger'); });
        }
        document.dispatchEvent(new CustomEvent('mpn:products-appended', { detail: { grid: g } }));
        b.classList.remove('is-loading');
        busy = false;
        if (!nn) { b.hidden = true; return; }
        // si le bas de la grille est encore visible (grand ecran), on enchaine
        requestAnimationFrame(function(){
          var r = b.getBoundingClientRect();
          if (r.top < window.innerHeight + 600) load();
        });
      })
      .catch(function(){ busy = false; fail(b); });
  }

  function setup(){
    var g = grid(), b = box();
    if (!g || !b) return;
    if (current === g) return;
    current = g;
    // place le bloc juste apres la grille (il peut avoir ete re-rendu par les filtres)
    if (b.previousElementSibling !== g) g.parentNode.insertBefore(b, g.nextSibling);
    busy = false;
    b.classList.remove('is-loading');
    b.querySelector('.mpn-inf__btn').hidden = true;
    fixWide(g);
    if (!g.getAttribute('data-mpn-next')) { b.hidden = true; return; }
    b.hidden = false;
    if (io) io.disconnect();
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) load(); });
    }, { rootMargin: '0px 0px 600px 0px' });
    io.observe(b);
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('.mpn-inf__btn');
    if (btn) { e.preventDefault(); load(); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  // filtres / tri : la grille est remplacee -> on se rebranche sur la nouvelle
  var t;
  new MutationObserver(function(){ clearTimeout(t); t = setTimeout(setup, 80); }).observe(document.body, { childList: true, subtree: true });
})();
